/**
 * @description src entry
 * @author wangfupeng
 */

// 全局注册自定义组件，用于渲染公式
import './register-custom-elem'

import module from './module/index'

export default module
